<template>
  <div class="dict">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('lossOverflowReport.form.title') }}</div
          >
        </template>
        <div class="collapse-content">
          <!-- 表单区域 -->
          <formItem ref="formItem" :params="params" :columns="baseColumns"></formItem>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('lossOverflowReport.form.baseTitle') }}</div
          >
        </template>
        <div class="collapse-content">
          <!-- 表单区域 -->
          <formItem
            ref="formItem"
            :params="params"
            :columns="columns"
            :rules="rules"
            :isEdit="isEdit"
            @changeCurrency="changeCurrency"
          ></formItem>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <el-tabs type="border-card" v-model="activeNameTab" class="addCooperationTabs">
          <el-tab-pane name="first" :label="$t('lossOverflowReport.form.productTitle')">
            <reportProduct
              ref="product"
              :defaultData="productData"
              :storageNo="params.storageNo"
              :departmentCode="params.decreaseOverflowDepartment"
              :decreaseOverflowType="params.decreaseOverflowType"
              :isEdit="isEdit"
            />
          </el-tab-pane>
        </el-tabs>
      </el-collapse-item>
      <el-collapse v-model="activeNames">
        <el-collapse-item name="4">
          <template slot="title">
            <div class="collapse-title-pre"
              ><span></span>{{ this.$t('applicationCredit.form.attachmentList') }}</div
            >
          </template>
          <div class="collapse-content">
            <upload
              ref="upload"
              @upload="uploadList"
              v-bind:tableData="attachmentList"
              v-bind:isShow="!isEdit"
            />
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-collapse>
    <div class="fixed-bottom-btnList" v-if="params.decreaseOverflowStatus != 1">
      <el-button type="primary" v-if="!isEdit" @click="saveData('0')" class="fixed-bottom-btn">{{
        $t('functionBtn.save')
      }}</el-button>
      <el-button
        v-if="!isEdit"
        type="primary"
        :loading="load"
        @click="saveData('1')"
        class="fixed-bottom-btn"
        >{{ $t('dialog.submit') }}</el-button
      >
      <el-button
        v-if="(params.decreaseOverflowStatus == 0 || params.decreaseOverflowStatus == 2) && isEdit"
        type="primary"
        :loading="load"
        @click="gotoEdit"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.edit') }}</el-button
      >
      <el-button
        v-if="params.decreaseOverflowStatus == 0 || params.decreaseOverflowStatus == 2"
        type="primary"
        :loading="load"
        @click="del"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.delete') }}</el-button
      >
      <!-- <el-button v-if="params.decreaseOverflowStatus ==3"
        type="primary"
        :loading="load"
        @click="handleAccountEntry"
        class="fixed-bottom-btn"
      >{{$t('addInvoice.btns.accountEntry')}}</el-button> -->
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import formItem from '../components/form-item';
  import reportProduct from './components/reportProduct';
  import rules from './rules/rules';
  import BASE_API from '@/api/dataBase.js';
  import upload from '@/components/upload';
  import API from '@/api/wareHouse/logisticsLossOverflowReport.js';
  import voucherMixins from '@/common/mixins/voucher.js';
  export default {
    mixins: [voucherMixins],
    components: {
      formItem,
      reportProduct,
      upload,
    },
    name: 'logisticsLossOverflowReportBaseEdit',
    data() {
      return {
        load: false,
        activeNames: ['1', '2', '3', '4'], //默认展开那些面板，
        rules: rules.formRules,
        productRules: rules.productRules,
        productData: [],
        attachmentList: [],
        statusData: ['已保存', '审批中', '已驳回', '已执行', '草稿'],
        params: {
          decreaseOverflowNo: null,
          decreaseOverflowCreateDate: null,
          decreaseOverflowCompanyName: null,
          decreaseOverflowCreatePerson: null,
          decreaseOverflowStatusName: null,
          voucherNo: null,
          decreaseOverflowType: null,
          storage: null,
          storageName: null,
          storageNo: null,
          decreaseOverflowDepartment: null,
          decreaseOverflowBusinessPerson: null,
          decreaseOverflowBusinessPersonName: null,
          decreaseOverflowBusinessPersonNo: null,
          decreaseOverflowReason: 'SYYY07',
          decreaseOverflowPart: 'SYHJ05',
          decreaseOverflowMark: null,
        },

        voucherFlag: 'AE_INV_STOCK_TAKING', //凭证标识
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      isEdit() {
        return this.$route.query.isEdit == 'Y';
      },
      baseColumns() {
        return [
          {
            prop: 'decreaseOverflowNo',
            name: this.$t('lossOverflowReport.search.decreaseOverflowNo'),
            type: 'input',
            disabled: true,
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowNoAdd'),
          },
          {
            prop: 'decreaseOverflowCreateDate',
            name: this.$t('lossOverflowReport.search.decreaseOverflowCreateDate'),
            type: 'date',
            disabled: true,
          },
          {
            prop: 'decreaseOverflowCompanyName',
            name: this.$t('lossOverflowReport.search.decreaseOverflowCompanyName'),
            type: 'input',
            disabled: true,
          },
          {
            prop: 'decreaseOverflowCreatePersonName',
            name: this.$t('lossOverflowReport.search.decreaseOverflowCreatePerson'),
            type: 'input',
            disabled: true,
          },
          {
            prop: 'decreaseOverflowStatusName',
            name: this.$t('lossOverflowReport.search.decreaseOverflowStatus'),
            type: 'input',
            disabled: true,
          },
          {
            prop: 'voucherNo',
            name: this.$t('lossOverflowReport.search.voucherNo'),
            type: 'input',
            disabled: true,
            placeholder: this.$t('lossOverflowReport.search.voucherNoPlaceholder'),
          },
        ];
      },
      columns() {
        return [
          {
            prop: 'decreaseOverflowType', //报损报溢类型
            name: this.$t('lossOverflowReport.search.decreaseOverflowType'),
            type: 'select',
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowTypePlaceholder'),
            clearable: true,
            options: [
              { label: '报损', value: '0' },
              { label: '报溢', value: '1' },
            ],
          },
          {
            prop: 'storageNo', //仓库
            name: this.$t('lossOverflowReport.search.storageNo'),
            type: 'searchTableSpec',
            searchType: 'warehouse',
            extraData: {
              currentStatus: 'ZT03',
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            currentValue: this.params.storageName ? this.params.storageName : null,
            checkRowKeys: [this.params.storageNo ? this.params.storageNo : null],
            isMultiple: true,
            changeMethod: 'changeCurrency',
          },
          {
            prop: 'decreaseOverflowDepartmentName', //部门
            name: this.$t('lossOverflowReport.search.decreaseOverflowDepartmentNo'),
            type: 'input',
            disabled: true,
          },
          {
            prop: 'decreaseOverflowBusinessPerson', //业务员
            name: this.$t('lossOverflowReport.search.decreaseOverflowBusinessPerson'),
            type: 'searchTableSpec',
            searchType: 'personnel',
            extraData: {
              partnerTypes: 'HZHB03,HZHB02',
              requestStatus: 'ZT03',
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            currentValue: this.params.decreaseOverflowBusinessPersonName
              ? this.params.decreaseOverflowBusinessPersonName
              : null,
            checkRowKeys: [
              this.params.decreaseOverflowBusinessPersonNo
                ? this.params.decreaseOverflowBusinessPersonNamo
                : null,
            ],
            isMultiple: true,
            changeMethod: 'changeCurrency',
          },
          {
            prop: 'decreaseOverflowReason',
            name: this.$t('lossOverflowReport.search.decreaseOverflowReason'),
            type: 'ajaxSelect',
            clearable: false,
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'profitandloss_reason' },
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowReasonPlaceholder'),
          },
          {
            prop: 'decreaseOverflowPart',
            name: this.$t('lossOverflowReport.search.decreaseOverflowPart'),
            type: 'ajaxSelect',
            clearable: false,
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'profit_loss_part' },
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowReasonPlaceholder'),
          },
          {
            prop: 'decreaseOverflowMark',
            name: this.$t('lossOverflowReport.search.decreaseOverflowMark'),
            type: 'input-area',
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowMarkPlaceholder'),
          },
        ];
      },
    },
    created() {
      if (this.$route.query.id) {
        //修改和详情会传报损报溢单号
        //获取详情
        this.getDetail();
      } else {
        let userInfo = this.userInfo.userInfo;
        this.params.decreaseOverflowCompanyNo = userInfo.companyCode; //公司代码
        this.params.decreaseOverflowCompanyName = userInfo.companyName; //公司名称
        this.params.decreaseOverflowCreatePersonNo = userInfo.userCode; //制单人名称
        this.params.decreaseOverflowCreatePersonName = userInfo.userName; //制单人编码
        this.params.decreaseOverflowStatusName = '';
        this.params.decreaseOverflowDepartment = userInfo.departmentCode; //部门编码
        this.params.decreaseOverflowDepartmentNo = userInfo.departmentCode; //部门编码
        this.params.decreaseOverflowDepartmentName = userInfo.departmentName; //部门名称
        let newDate = new Date();
        this.params.decreaseOverflowCreateDate = newDate;
      }
    },
    methods: {
      //获取详情
      getDetail() {
        this.$axios.post(API.DETAIL_API + '/' + this.$route.query.id).then((res) => {
          if (res.data.code === 0) {
            this.params = res.data.data;
            this.productData = this.params.detailList;
            console.log(this.productData);
            if (this.productData && this.productData.length > 0) {
              this.productData.map(async (item) => {
                if (item.decreaseOverflowPackage == null) {
                  item.decreaseOverflowPackage = '';
                }
                item.newDecreaseOverflowPercent =
                  Number(item.decreaseOverflowPercent, 100).toFixed(6) + '%';
                // let params = {
                //   batchNo: item.batchNo,
                // };
              });
            }
            this.attachmentList = this.params.distributionAttachmentDos;
            this.params.decreaseOverflowStatusName =
              this.statusData[this.params.decreaseOverflowStatus];
            // 仓库
            // this.params.storage={
            //   storageName: this.params.storageName||null,
            //   storageNo: this.params.storageNo||null,
            // }
            //部门
            this.params.decreaseOverflowDepartment =
              this.params.decreaseOverflowDepartmentNo || null;
            this.$nextTick(() => {
              this.$refs.formItem.clearValidate();
            });

            /*  // 获取凭证ID 获取凭证列表
          this.entityDataId = this.params.id;
          this.getAccountEntry() */
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //修改表单信息
      changeCurrency(obj) {
        //仓库
        if (obj.prop == 'storageNo') {
          if (obj.val && obj.val[0].storageCode != this.params.storageNo) {
            this.params.storageName = obj.val ? obj.val[0].storageName : null;
            this.params.storageNo = obj.val ? obj.val[0].storageCode : null;
            this.productData = [];
          } else {
            this.params.storageName = null;
            this.params.storageNo = null;
            this.params.storage = null;
            this.productData = [];
          }
        } else if (obj.prop == 'decreaseOverflowBusinessPerson') {
          this.params.decreaseOverflowBusinessPersonNo = obj.val ? obj.val[0].id + '' : null;
          this.params.decreaseOverflowBusinessPersonName = obj.val ? obj.val[0].personName : null;
        } else if (obj.prop == 'decreaseOverflowDepartment') {
          this.params.decreaseOverflowDepartmentPersonName = obj.val ? obj.val.label : null;
          this.params.decreaseOverflowDepartmentPersonNo = obj.val ? obj.val.id : null;
          this.params.decreaseOverflowDepartment = obj.val ? obj.val.id : null;
          this.productData = [];
        }
      },
      //更新附件列表
      uploadList(value) {
        this.attachmentList = value;
      },
      //保存/提交
      saveData(type) {
        const that = this;
        //基本信息-验证
        const base = this.$refs.formItem.submit(type);
        //产品明细-验证
        const product = this.$refs.product.submit(type);
        //获取产品明细
        const goodsList = this.$refs.product.getValues();
        //如果是提交  需要校验商品行项目
        if (goodsList.length == 0 && type == '1') {
          this.$message({
            showClose: true,
            message: this.$t('xTable.saveNoData'),
            type: 'error',
          });
          return;
        }
        Promise.all([base, product]).then(() => {
          that.load = true;
          // 获取基础信息值
          const baseData = this.$refs.formItem.getValues();
          baseData.decreaseOverflowStatus = type;
          baseData.detailList = goodsList;
          baseData.distributionAttachmentDos = this.attachmentList;
          let url = type == '0' ? API.SAVE_API : API.SUBMIT_API;
          that.$axios.post(url, baseData).then((res) => {
            that.load = false;
            if (0 != res.data.code) {
              if (type === '1') {
                if (res.data.data) {
                  if (that.$route.name == 'lossOverflowReportAdd') {
                    that.dblclickEvent(res.data.data);
                  } else {
                    that.getDetail();
                  }
                }
              }
              that.$alert(res.data.msg);
            } else {
              if (type == '0') {
                if (that.$route.name == 'logisticsLOReportAdd') {
                  that.dblclickEvent(res.data.data);
                } else {
                  that.getDetail();
                }
              } else {
                that.gotoList(false);
              }
              that.$message({
                showClose: true,
                message: res.data.msg || that.$t('message.success'),
                type: 'success',
              });
            }
          });
        });
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/wareHouse/logisticsLOReportAdd',
            name: 'logisticsLOReportAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/wareHouse/logisticsLOReportDetail',
            name: 'logisticsLOReportDetail',
            meta: {
              keepAlive: false,
            },
            query: { id: value.id, isEdit: 'Y' },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //删除
      del() {
        const that = this;
        this.$confirmAction()
          .then(() => {
            that.$axios.post(API.DEL_API, [this.$route.query.id]).then((res) => {
              that.load = false;
              if (0 != res.data.code) {
                that.$alert(res.data.msg);
              } else {
                that.gotoList(false);
                that.$message({
                  showClose: true,
                  message: res.data.msg || that.$t('message.success'),
                  type: 'success',
                });
              }
            });
          })
          .catch(() => {
            this.load = false;
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //跳转到列表页面
      gotoList(flag) {
        let oldPath = 'logisticsLOReportAdd';
        let oldName = 'logisticsLOReportAdd';
        if (this.$route.query.id && this.isEdit) {
          oldPath = 'logisticsLOReportEdit';
          oldName = 'logisticsLOReportEdit';
        } else if (this.$route.query.id && !this.isEdit) {
          oldPath = 'logisticsLOReportDetail';
          oldName = 'logisticsLOReportDetail';
        }
        let path = {
          fromPath: {
            path: '/wareHouse/' + oldPath,
            name: oldName,
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/wareHouse/logisticsLOReportList',
            name: 'logisticsLOReportList',
            meta: {
              keepAlive: flag,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //跳转到编辑页面
      gotoEdit() {
        let path = {
          fromPath: {
            path: '/wareHouse/logisticsLOReportDetail',
            name: 'logisticsLOReportDetail',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/wareHouse/logisticsLOReportEdit',
            name: 'logisticsLOReportEdit',
            meta: {
              keepAlive: false,
            },
            query: { id: this.$route.query.id, isEdit: 'N' },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .collapse-main-content {
    margin-bottom: 10px;
  }
</style>
<style>
  .el-collapse-item__wrap {
    overflow: inherit !important;
  }
</style>
